var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadGooglePlay = function SvgDownloadGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 45,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D4029",
    d: "M0 7.923C0 3.545 3.968 0 8.868 0h152.264c4.9 0 8.868 3.545 8.868 7.923v29.155c0 4.377-3.968 7.922-8.868 7.922H8.868C3.968 45 0 41.455 0 37.078z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77.4 24.71c-2.67 0-4.85 2.03-4.85 4.83s2.18 4.83 4.85 4.83 4.85-2.05 4.85-4.83c0-2.8-2.18-4.83-4.85-4.83m0 7.76c-1.46 0-2.73-1.21-2.73-2.93s1.26-2.93 2.73-2.93 2.73 1.19 2.73 2.93-1.26 2.93-2.73 2.93m-10.58-7.76c-2.67 0-4.85 2.03-4.85 4.83s2.18 4.83 4.85 4.83 4.85-2.05 4.85-4.83-2.18-4.83-4.85-4.83m0 7.76c-1.46 0-2.73-1.21-2.73-2.93s1.26-2.93 2.73-2.93 2.73 1.19 2.73 2.93c0 1.72-1.26 2.93-2.73 2.93m-12.58-6.28v2.05h4.91c-.15 1.15-.53 1.99-1.12 2.58-.71.71-1.83 1.5-3.79 1.5-3.02 0-5.38-2.43-5.38-5.45s2.36-5.45 5.38-5.45c1.63 0 2.82.64 3.7 1.46l1.45-1.45c-1.23-1.17-2.85-2.07-5.14-2.07-4.14 0-7.61 3.37-7.61 7.5s3.48 7.5 7.61 7.5c2.23 0 3.92-.73 5.23-2.1 1.35-1.35 1.78-3.26 1.78-4.79 0-.47-.04-.91-.11-1.28h-6.91m51.47 1.59c-.4-1.08-1.63-3.08-4.14-3.08s-4.56 1.96-4.56 4.83c0 2.71 2.05 4.83 4.8 4.83 2.21 0 3.5-1.35 4.03-2.14l-1.65-1.1c-.55.81-1.3 1.34-2.38 1.34s-1.85-.49-2.34-1.46l6.46-2.67zm-6.59 1.61c-.05-1.87 1.45-2.82 2.53-2.82.84 0 1.56.42 1.79 1.02l-4.32 1.79zm-5.25 4.68h2.12v-14.2h-2.12zm-3.48-8.29h-.07c-.48-.57-1.39-1.08-2.54-1.08-2.42 0-4.63 2.12-4.63 4.85s2.21 4.81 4.63 4.81c1.15 0 2.07-.51 2.54-1.1h.07v.7c0 1.85-.99 2.84-2.58 2.84-1.3 0-2.1-.93-2.43-1.72l-1.85.77c.53 1.28 1.94 2.85 4.28 2.85 2.49 0 4.59-1.46 4.59-5.03V25h-2.01v.79zm-2.43 6.68c-1.46 0-2.69-1.23-2.69-2.91s1.23-2.95 2.69-2.95 2.58 1.24 2.58 2.95-1.13 2.91-2.58 2.91m27.7-12.59h-5.08v14.2h2.12v-5.38h2.96c2.35 0 4.66-1.7 4.66-4.41s-2.31-4.41-4.66-4.41m.05 6.84h-3.01v-4.87h3.01c1.58 0 2.49 1.31 2.49 2.43s-.9 2.43-2.49 2.43zm13.1-2.04c-1.53 0-3.12.68-3.78 2.17l1.88.79c.4-.79 1.15-1.04 1.94-1.04 1.1 0 2.21.66 2.23 1.83v.15c-.38-.22-1.21-.55-2.21-.55-2.03 0-4.09 1.11-4.09 3.2 0 1.9 1.66 3.12 3.53 3.12 1.43 0 2.21-.64 2.7-1.39h.07v1.1h2.05v-5.44c0-2.52-1.88-3.93-4.31-3.93zm-.26 7.78c-.69 0-1.66-.35-1.66-1.21 0-1.1 1.21-1.52 2.25-1.52.93 0 1.37.2 1.94.47a2.57 2.57 0 0 1-2.52 2.25zm12.02-7.47-2.43 6.16h-.07l-2.52-6.16h-2.28l3.78 8.61-2.16 4.79h2.21l5.83-13.39h-2.36zm-19.09 9.09h2.12v-14.2h-2.12zM53.87 11.64c0 .95-.28 1.71-.85 2.28-.64.67-1.48 1.01-2.5 1.01s-1.82-.34-2.51-1.02-1.03-1.53-1.03-2.54.34-1.86 1.03-2.54 1.52-1.02 2.51-1.02c.49 0 .96.1 1.4.29s.8.44 1.07.76l-.6.6c-.45-.54-1.07-.81-1.87-.81-.72 0-1.34.25-1.86.76-.52.5-.78 1.16-.78 1.97s.26 1.46.78 1.97c.52.5 1.14.76 1.86.76.76 0 1.4-.25 1.9-.76q.495-.495.57-1.38h-2.48v-.82h3.3c.03.18.05.35.05.51zM59.1 8.79H56v2.16h2.8v.82H56v2.16h3.1v.84h-3.98V7.95h3.98zM62.8 14.77h-.88V8.79h-1.9v-.84h4.68v.84h-1.9zM68.09 14.77V7.95h.88v6.82zM72.85 14.77h-.88V8.79h-1.9v-.84h4.68v.84h-1.9zM83.62 13.89c-.67.69-1.5 1.03-2.5 1.03s-1.83-.34-2.5-1.03-1-1.53-1-2.53.33-1.84 1-2.53 1.5-1.03 2.5-1.03 1.82.35 2.49 1.04 1.01 1.53 1.01 2.52-.33 1.84-1 2.53m-4.35-.57c.51.51 1.12.77 1.85.77s1.35-.26 1.85-.77.76-1.16.76-1.96-.25-1.44-.76-1.96c-.5-.51-1.12-.77-1.85-.77s-1.35.26-1.85.77-.76 1.16-.76 1.96.25 1.44.76 1.96M85.85 14.77V7.95h1.07l3.31 5.3h.04l-.04-1.31V7.95h.88v6.82h-.91l-3.47-5.56h-.04l.04 1.31v4.25h-.88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.23,
    d: "M53.87 11.64c0 .95-.28 1.71-.85 2.28-.64.67-1.48 1.01-2.5 1.01s-1.82-.34-2.51-1.02-1.03-1.53-1.03-2.54.34-1.86 1.03-2.54 1.52-1.02 2.51-1.02c.49 0 .96.1 1.4.29s.8.44 1.07.76l-.6.6c-.45-.54-1.07-.81-1.87-.81-.72 0-1.34.25-1.86.76-.52.5-.78 1.16-.78 1.97s.26 1.46.78 1.97c.52.5 1.14.76 1.86.76.76 0 1.4-.25 1.9-.76q.495-.495.57-1.38h-2.48v-.82h3.3c.03.18.05.35.05.51zM59.1 8.79H56v2.16h2.8v.82H56v2.16h3.1v.84h-3.98V7.95h3.98zM62.8 14.77h-.88V8.79h-1.9v-.84h4.68v.84h-1.9zM68.09 14.77V7.95h.88v6.82zM72.85 14.77h-.88V8.79h-1.9v-.84h4.68v.84h-1.9zM83.62 13.89c-.67.69-1.5 1.03-2.5 1.03s-1.83-.34-2.5-1.03-1-1.53-1-2.53.33-1.84 1-2.53 1.5-1.03 2.5-1.03 1.82.35 2.49 1.04 1.01 1.53 1.01 2.52-.33 1.84-1 2.53Zm-4.35-.57c.51.51 1.12.77 1.85.77s1.35-.26 1.85-.77.76-1.16.76-1.96-.25-1.44-.76-1.96c-.5-.51-1.12-.77-1.85-.77s-1.35.26-1.85.77-.76 1.16-.76 1.96.25 1.44.76 1.96ZM85.85 14.77V7.95h1.07l3.31 5.3h.04l-.04-1.31V7.95h.88v6.82h-.91l-3.47-5.56h-.04l.04 1.31v4.25h-.88Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-google-play_svg__a)",
    d: "M11.86 8.56c-.33.35-.53.89-.53 1.6v25.12c0 .7.2 1.25.53 1.6l.08.08 14.07-14.07v-.33L11.94 8.49l-.08.08z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-google-play_svg__b)",
    d: "m30.7 27.58-4.69-4.69v-.33l4.69-4.69.11.06 5.56 3.16c1.59.9 1.59 2.38 0 3.28l-5.56 3.16-.11.06z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-google-play_svg__c)",
    d: "m30.81 27.52-4.8-4.8-14.16 14.16c.52.55 1.39.62 2.36.07l16.59-9.43z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-google-play_svg__d)",
    d: "M30.81 17.92 14.22 8.49c-.97-.55-1.84-.48-2.36.07l14.16 14.16 4.8-4.8z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-google-play_svg__a",
    x1: 24.77,
    x2: 5.7,
    y1: 9.89,
    y2: 28.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-google-play_svg__b",
    x1: 38.43,
    x2: 10.95,
    y1: 22.72,
    y2: 22.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-google-play_svg__c",
    x1: 28.2,
    x2: 2.35,
    y1: 25.33,
    y2: 51.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-google-play_svg__d",
    x1: 8.29,
    x2: 19.83,
    y1: 0.2,
    y2: 11.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
};
export default SvgDownloadGooglePlay;